import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import AdminDashboard from "@/pages/AdminDashboard";
import ScheduleCalendar from "@/pages/ScheduleCalendar";
import Requests from "@/pages/Requests";
import Staff from "@/pages/Staff";
import TechHome from "@/pages/TechHome";
import TechRequests from "@/pages/TechRequests";
import Comms from "@/pages/Comms";
import AssistantAgent from "@/pages/AssistantAgent";
import Donate from "@/pages/Donate";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Support from "@/pages/Support";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Loading() {
  return (
    <div className="rs-grid-bg min-h-screen flex items-center justify-center">
      <div className="font-mono-rs text-[#00F0FF] tracking-[0.3em] animate-pulse">INITIALIZING…</div>
    </div>
  );
}

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/dashboard" : "/my-schedule"} replace />;
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/dashboard" : "/my-schedule"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/" element={<RootRedirect />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/dashboard" element={<Protected role="admin"><AdminDashboard /></Protected>} />
              <Route path="/schedule" element={<Protected role="admin"><ScheduleCalendar /></Protected>} />
              <Route path="/requests" element={<Protected role="admin"><Requests /></Protected>} />
              <Route path="/staff" element={<Protected role="admin"><Staff /></Protected>} />
              <Route path="/assistant" element={<Protected role="admin"><AssistantAgent /></Protected>} />
              <Route path="/my-schedule" element={<Protected role="tech"><TechHome /></Protected>} />
              <Route path="/my-requests" element={<Protected role="tech"><TechRequests /></Protected>} />
              <Route path="/comms" element={<Comms />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
